module.exports = __webpack_public_path__ + "static/img/newlogo.545a678.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bookpic/newlogo.png
// module id = iuGy
// module chunks = 1